/*
 * @Author: JettyHuang
 * @LastEditors: JettyHuang
 * @Description:
 * @Date: 2021-03-03 18:15:48
 * @LastEditTime: 2021-03-29 13:38:14
 * @FilePath: /yft-b2c-web-h5/src/pages/Shop/Member/Personal/MyCollect/MyCollectMod.js
 */
import { observable, action, flow } from 'mobx';
import { Toast } from 'antd-mobile';
import Util from 'utils';
import Config from 'config/Config';
import Serv from './MyCollectServ';

class MyCollectMod {
  @observable collectList = [];
  @action
  changeState(obj) {
    Object.keys(obj).forEach((key) => {
      this[key] = obj[key];
    });
  }

  /**
   * 获取收藏列表
   */
  getCollectList = flow(function* () {
    try {
      const { data } = yield Serv.getCollectList();

      let list = data || [];
      let invalidList = [];
      for (let i = list.length - 1; i >= 0; i--) {
        if (`${list[i].status}` == '2') {
          invalidList.unshift(list.splice(i, 1)[0]);
        }
      }
      list = list.concat(invalidList);

      this.collectList = list;
    } catch (error) {}
  });

  /**
   * 收藏/取消收藏
   * 取消收藏 id name price activityId
   * 收藏 itemId activeId id name price
   */
  collect = flow(function* (isCollected, list, activityId, activityType) {
    console.log('lllll', list);
    try {
      const ids = list.map((item) => item.id);
      const activeIds = [];
      list.map((item) => {
        if (!!item.activeId) {
          activeIds.push(item.activeId);
        }
      });
      console.log('activeIds', activeIds);
      const isAddSign = activeIds.length > 0;
      const url = isCollected
        ? `user/collection/collection/delete?activeId=${activityId ? activityId : ''}`
        : isAddSign
          ? 'user/collection/collection/save'
          : 'user/collection/collection/add';
      const resultData = isCollected
        ? yield Serv.collect(url, ids)
        : yield Serv.collect(url, isAddSign ? list[0] : ids);

      if (isCollected) {
        Toast.info('取消收藏成功', 1);
      }
      // 神策数据发送
      const analysisData = list.map((item) => ({
        commodity_id: item.id,
        commodity_name: item.name,
        price: item.price || '',
        source: 'H5' // 来源
      }));
      // fix 20211116，铁匠：批量的暂时不埋点，所以只埋单个收藏的操作
      if (!!analysisData && analysisData.length == 1) {
        window.sensors.track(isCollected ? 'favoriteDel' : 'favoriteAdd', analysisData[0]);
        // window.sensors.track(isCollected ? 'favoriteDel' : 'favoriteAdd', { arr: JSON.stringify(analysisData) });
      }

      return { isCollected: !isCollected, resultData };
    } catch (error) {
      console.log(error);
    }
    return false;
  });
}

export default MyCollectMod;



// WEBPACK FOOTER //
// ./src/pages/Shop/Member/Personal/MyCollect/MyCollectMod.js